import './oiMenu.css';
import React from 'react'
import History from '../../History';

const oiMenu = (props) => {
    const logout = () => {
        sessionStorage.clear();
        History.push(`${process.env.PUBLIC_URL}/`);
    };

    return (
        <div id="oi-menu" style={{ width: props.widthContainer }}>
            <div
                id="oi-menu-layer"
                onClick={props.clickEvent}
                style={{ width: props.widthLayer }}>
            </div>

            <div
                id="oi-menu-list"
                style={{ width: props.widthMenu }}>

                <div id="oi-menu-list-tile-card">
                    <h2>{props.phoneNumber}</h2>
                    <span onClick={() => { logout() }}>Encerrar Sessão</span>
                </div>

                <ul >
                    <li onClick={() => { History.push(`${process.env.PUBLIC_URL}/noticias`) }}>Notícias</li>
                    <li onClick={() => { History.push(`${process.env.PUBLIC_URL}/interesses`) }}>Interesses</li>
                    <li onClick={() => { History.push(`${process.env.PUBLIC_URL}/sobre`) }}>Sobre</li>
                </ul>
            </div>
        </div>
    );
};

export default oiMenu;


// WEBPACK FOOTER //
// ./src/components/oiMenu/oiMenu.js